import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import Providers from "@web-ui/providers";
import { Console } from "@/shell/console";
import "./app.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Providers storageKey="viewform-console-theme">
      <Console />
    </Providers>
  </StrictMode>,
);
